import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getToken } from '../../utils/token';

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_URL,
    prepareHeaders: (headers) => {
      const token = getToken();
      if (token) {
        headers.set('Authorization', `Bearer ${token}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    login: builder.mutation({
      query: (credentials) => ({
        url: `${process.env.REACT_APP_API_URL}/login`,
        method: 'POST',
        body: credentials,
      }),
    }),
    roleModule: builder.mutation({
      query: (data) => ({
        url: `${process.env.REACT_APP_API_URL}/api/roleModule`,
        method: 'POST',
        body: data,
      }),
    }),
  }),
});

export const { useLoginMutation,useRoleModuleMutation } = authApi;
